export default {
  nav: {
    home: "መእተዊ",
    lab: "ናይ ጽገና ክፍሊ",
    phones: "ቴለፎናት",
    showroom: "ናይ ንዋያት ክፍሊ",
    visit: "ይቐረቡና እና ይረኽቡና",
    getEstimate: "ግምት ወገን",
    openMenu: "ምናሌ ክፈት",
    closeMenu: "ምናሌ ዕጸው",
    menu: "ምናሌ",
    sound: "ድምጺ",
    call: "ደውሉ",
    tagline: "ቴለፎን ምርኣይ · ካልጋሪ",
  },
  status: {
    openNow: "ሕጂ ክፉት እዩ",
    closed: "ዝግው እዩ",
    until: "ክሳብ",
    opensToday: "ሎሚ ክኸፍት እዩ ብ",
    opensTomorrow: "ጽባሕ ክኸፍት እዩ ብ",
    opensSunday: "ሰንበት ክኸፍት እዩ ብ",
  },
  hero: {
    h1a: "ዝተሰብረ ቴክኖሎጂ፣",
    h1b: "ብምዕራፍ",
    h1c: "ናብ ህይወት ንምልሶ።",
    sub: "Next-G Phone Repair ቴለፎናት፣ ላፕቶፓትን ናይ መዓልታዊ ቴክኖሎጂን ኣብ ካልጋሪ ኣብ ትክክለኛ ቦታ ስራሕ የጽግን — ቀጥተኛ መልስታት፣ ምዕራፍ ስራሕ፣ እና ብዘይ ፍቓድኩም ስራሕ ኣይጅምርን።",
    ctaQuote: "ናይ ጽገና ግምት ርኸቡ",
    ctaVisit: "ድኳኑ ይቐረቡ",
    est: "ካልጋሪ፣ AB",
    badge: "ግዢ እና ጽገና",
  },
  marquee: [
    "ናይ ስክሪን ጽገና", "ናይ ባትሪ ለውጢ", "ናይ ቻርጅ መኽፈቢ", "ናይ ማይ ጉድኣት",
    "ናይ ካሜራ ክፍልታት", "ናይ ዳታ ምምላስ", "ናይ ላፕቶፕ ክብካብ", "ናይ ሶፍትዌር ምድሓን",
  ],
  process: {
    chapter: "01",
    eyebrow: "ናይና ኣገባብ ስራሕ",
    title: "ኣርባዕተ ደረጃታት። ብዘይ ምስጢር፣ ብዘይ ጸቕጢ።",
    lede: "ኣብ Next-G ኩሉ ጽገና ሓደ ተመሳሳሊ ቅሩብ ህythmos የከትል — ንዓ መሳርሒኹም እንታይ ከም ዝግበርን ክንደይ ከም ዝኽወንን ኩሉ ግዜ ትፈልጡ።",
    steps: [
      { num: "01", title: "አምጽእዎ", body: "ነቲ መሳርሒ ከም ዝኾነ ስለዝዀነ አምጽእዎ — ብዘይ ቆጸራ፣ ብዘይ መዐቅቢ፣ ብዘዮም ቅጽዓት። ማይ ኤርገኖ እንተኾይኑ፣ ጸዒኹም ሒዝክዎ ብቀጥታ ንእተው።" },
      { num: "02", title: "ንምርምር", body: "ንኽፍቶ፣ ነቲ ሃርድዌር ንፈትሾ፣ ብትሕዝትነት እንታይ ከም ዝተሰብረን እንታይ ከም ዘይተሰብረን ንነግረኩም። ብዘይ ቴክኒካዊ ቃላት፣ ብዘይ ግምት።" },
      { num: "03", title: "ኹምት ትፅድቕ", body: "ቅድሚ ምጅማር ስራሕ ግልጺ ዋጋ ብ CAD ትረክቡ። ኹምት እዚ እንተዘይበልኩም ስራሕ ኣይጅምርን — ክጽግን ከም ዘይግብኦ እውን ንነግረኩም።" },
      { num: "04", title: "ናብ ኢድኩም ይምለስ", body: "ንጽግኖ፣ ኩሉ ተግባር እንደገና ንፈትሾ፣ ነቲ መሳርሒ ዝሰርሕ ንህበኩም — ነቲ ኣሮጌ ክፍሊ ክትርእይዎ እንተደሊኹም ኣለና።" },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "ነዚ ንጽግን",
    title: "ቴለፎናት፣ ላፕቶፓትን ኩሉ ነገር ኩሉ መዓልቲ ትምነክሥዎን።",
    items: [
      { title: "ቴለፎን ምርኣይ", body: "ስክሪናት፣ ባትሪታት፣ መኽፈብታት፣ ካሜራታትን ናይ ማይ ጉድኣትን ን iPhone እና Android።" },
      { title: "ናይ ላፕቶፕ ጽገና", body: "MacBook እና Windows ላፕቶፓት — ናይ ሃርድዌር ጽገናታት፣ ምዕቃባትን ዝንቀሳቐሱ ስርዓታት ምድሓንን።" },
      { title: "ናይ ሶፍትዌር ደገፍ", body: "ናይ ምጅማር ጸገማት፣ ዘይተሳኽዑ ምሕደሳታት፣ ምቕራባትን ናይ ኣካውንት ጸገማትን ብምህሮ ይፍታሕ።" },
      { title: "ናይ መሳርሒ ምርመራ", body: "እንታይ ከም ዝኾነ ኣይትፈልጥን ዲኹም? ናይ ስራሕ ቦታ ምርመራ ብትኽክል እንታይ ከም ዝኸውን የነግርኩም።" },
      { title: "ናይ ተተላላኺ ንዋያት ክፍሊ", body: "ከድኒታት፣ መከላኸልታት፣ ቻርጀራት፣ ድምጺ እና ናይ ፈጠራ መሳርሒታት — ኣብ ድኳን ይራግብ።" },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "ኣብ ሓደ ደቒቕ ግምት",
    titleA: "ጸገሙ ምረጽ።",
    titleEm: "ድሕሪኡ ደውል",
    titleB: "— ብቀጥታ ዋጋ ንህበካ።",
    body: "መሳርሒኻ እና ጸገም ምረጽ — ድሕሪኡ ነዚ ዝርዝር ሒዝካ ንድኳን ደውል እና ብቀጥታ ቀጥተኛ እና ቅሩብ ዋጋ ርኸብ።",
    steps: ["መሳርሒኻ ምረጽ", "ጸገም ምረጽ", "ብዝርዝር ደውል"],
    ctaStart: "ግምቱ ጀምር",
    ctaCall: "ደውሉ",
    pricesLabel: "ቅኑዕ ናይ መነሾ ዋጋታት",
    prices: ["ኩሉ ጽገና ካብ CA $79 ጀሚሩ", "ስክሪናት፣ ባትሪታት፣ መእተዊታት፣ ካሜራታት እና ካልኦት", "ምርመራ ኩሉ ግዜ ነፃ"],
  },
  location: {
    chapter: "04",
    eyebrow: "ድኳኑ ርኸቡ",
    titleEm: "— TD Bank ጎድኒ።",
    lede: "ብዘይ ቆጸራ ምኻድ የፍቅድ። ነቲ መሳርሒ ከም ዝኾነ አምጽእዎ፣ ቀሪቡ ንሕና ንዐንዶ።",
    openMaps: "ኣብ ካርታ ክፈት",
    visitContact: "ቆጸራ እና ርክብ",
  },
  lab: {
    chapter: "ናይ ጽገና ክፍሊ",
    eyebrow: "ኣገልግሎታት",
    titleA: "ኩሉ ጽገና፣",
    titleEm: "ብቀሊል ቋንቋ ተገሊጹ።",
    lede: "ዝኾነ ኣገልግሎት ጠውቕዎ እንታይ ከም ዝሸፍንን ኣየኖያት ምልክታት ከም ዝፈትሕን ንምርኣይ። ግምት ምሕጽንታ ኩሉ ግዜ ነጻ እዩ — እና ስራሕ ኩሉ ግዜ ብፍቓድኩም ጸዒኑ ይጅምር።",
    notice: "ክትርእዮም ዝኽእሉ",
    ask: "ግምት ሓትቱ",
    pricingTitle: "ዋጋ ኣብዚ ብኸምዲ ይሰርሕ",
    pricingBody: "ናይ ኦንላይን ክልልታት ብ CAD ቅዳሞት ናይ እቅድ ቁጽርታት እዮም። ናይ መወዳእታ ዋጋ ነቲ መሳርሒ ምስ ፈተሽና፣ ትኽክለኛ ሞዴል ምስ ፈልጥናን ናይ ክፍልታት ምርካብ ምስ ገምገምናን ይረጋገጽ — እና ስራሕ ኹምት ግምቱ ምስ ፀድቕ ብቛ ይጅምር።",
    ctaTitleA: "ኣየናይ ከም ዝጸግን ኣይትፈልጥን ዲኹም?",
    ctaTitleEm: "ብቛ ሓትቱ።",
    ctaBody: "ነቲ መሳርሒ እንታይ ከም ዝገብር ገለጹ — ትኽክለኛ ጽገና ንኣርእየኩም።",
    ctaQuote: "ናይ ጽገና ግምት ርኸቡ",
    ctaCall: "ደውሉ",
    services: {
      screen: {
        title: "ናይ ምስባር ስክሪን ጽገና",
        blurb: "ዝተሰንደቐ መስታወት፣ ዝሞቱ ፒክስላት፣ ኣብ ስክሪን መስመራት ወይ ዘይሰርሕ ናይ ምንካፍ ክፍሊ። ኣብ ቴለፎናት፣ ታብሌታት እና ላፕቶፓት ስክሪናት ብጽሩይ ተመሳሳሊ ክፍልታት ንለውጥ።",
        symptoms: ["ዝተሰንደቐ ወይ ዝተሰብረ መስታወት", "ምንካፍ ኣይሰርሕን", "መስመራት፣ ነጥብታት ወይ ጸሊም ከባቢታት", "ስክሪኑ ጸሊም እዩ ግን ቴለፎኑ ይንቀሳቐስ"],
      },
      battery: {
        title: "ናይ ባትሪ ለውጢ",
        blurb: "ቴለፎንኩም ኣብ 30% እንተ ሞይቱ፣ ኣብ ልዊጥ እንተ ጠፊኡ ወይ ሙሉኡ መዓልቲ ኣብ ቻርጀር እንተ ዝነብር፣ ሓዲሽ ባትሪ ኣብ ኣብዛሻ እዚ ይምልሶ። ጥዕና ቅድሚ እና ድሕሪኡ ይፈተሽ።",
        symptoms: ["ባትሪታት ኣብ ሰዓታት ይውድቅ", "ዘይተጸበየ ምጥፋእ", "ባትሪ ህንፋሕ ስክሪኑ ደው የልግስ", "ኣብ ሶኬት ምስ ዝተጠምጠም ብቛ ይሰርሕ"],
      },
      charging: {
        title: "ናይ ቻርጅ መኽፈቢ እና ናይ ሓይሊ ጸገማት",
        blurb: "ዝንቀሳቐሱ ኬብላት፣ ዝንቀሳቐስ ቻርጅ ወይ ብሓደ ቅርጽ ብቛ ዝሙላ ቴለፎን። ናይ ቻርጅ መኽፈብታት ንጽረግ፣ ንጽግን ወይ ንለውጥ እና ናይ ሓይሊ ጸገማት ክሳብ ቦርድ ንከታተል።",
        symptoms: ["ኬብሉ ይንቀሳቐስ ወይ ይውድቅ", "ብሓደ ቅርጽ ብቛ ይሙላ", "ፍጹም ኣይሙላን", "ዘይኬብል ቻርጅ ይሰርሕ መኽፈቡ ግን ኣይኮነን"],
      },
      backglass: {
        title: "ናይ ድሕሪት መስታወት እና ናይ ካብሌት ጉድኣት",
        blurb: "ዝተሰንደቐ ናይ ድሕሪት መስታወት እና ዝተጎተተ ፍሬም ካብ ቅርጺ ልዕሊ እዩ — ለማን እና ርጥበት የእትዎ። ናይ ድሕሪት መስታወት ንለውጥ እና ካብሌታት ንምምላስ ነቲ መሳርሒ እንደገና ንዕጽዎ።",
        symptoms: ["ዝተሰንደቐ ወይ ዝተሰብረ ናይ ድሕሪት መስታወት", "ቴለፎኑ ምስ ዝዀነ ስለስት ሓረርቲ ደረትታት", "ዝተጎተተ ወይ ዝተጠፍአ ፍሬም", "ናይ ካሜራ ቀለቤት ዝተፈትሐ ወይ ዝንቀሳቐስ"],
      },
      camera: {
        title: "ናይ ካሜራ ለውጢ እና ጽገና",
        blurb: "ዘይንጹር ስእልታት፣ ዝንቀሳቐስ ሌንዝ፣ ናይ ትኩረት ጸገም ወይ ጸሊም ዝኽፈት ናይ ካሜራ መተግበሪ። ናይ ሌንዝ መስታወት እና ናይ ካሜራ ሞጁላት ቅድሚትን ድሕሪትን ንለውጥ።",
        symptoms: ["ስእልታት ኩሉ ግዜ ዘይንጹራት እዮም", "ካሜራ ይንቀሳቐስ ወይ ይንጸባራቐስ", "ኣብ ናይ ካሜራ መተግበሪ ውስጥ ጸሊም ስክሪን", "ዝተሰንደቐ ናይ ሌንዝ መስታወት"],
      },
      water: {
        title: "ናይ ማይ ጉድኣት ግምገማ",
        blurb: "ማይ ኣብ ውሽጢ መሳርሒ ምስ ኮሮዥን ናይ ቅልጽም ውድድር እዩ። ጸዒኹም ሒዝክዎ — ንኽፍቶ፣ ኮሮዥኑ ንጽርግ ንዚ ዝድሓን ቅድሚ ዝኾነ ዋጋ ንግምግም።",
        symptoms: ["ኣብ ማይ ወዲቑ ወይ ፈሳሲ ተንስክዎ", "ምስ ተርጥቦ ስክሪኑ ይንገላታ", "ቴለፎኑ ድሕሪ ፈሳሲ ማይ ሞይቱ", "ርጥበት ኣብ ትሕቲ ካሜራ ወይ ስክሪን ይርአ"],
      },
      software: {
        title: "ሶፍትዌር፣ ምቕራባት እና ናይ ምጅማር ጸገማት",
        blurb: "ኣብ ሎጎ ተላጊፉ፣ ዘይተሳኽዑ ምሕደሳታት፣ ዘይቋረጽ ምቕራባት ወይ ዝተዓጽዉ ኣካውንታት። ናይ ሶፍትዌር ጸገማት ንፈትሕ፣ ስርዓታት ንምልስ ናብ መሳርሒኹም ከም እትእትዉ ንሕግዘኩም።",
        symptoms: ["ኣብ ናይ ምጅማር ሎጎ ተላጊፉ", "ምሕደሳ ኣይተሳኽአን መሳርሂታት ኣይጅምሩን", "መተግበርታት ኩሉ ግዜ ይቕረቡ", "ካብ ኣካውንትኹም ወይ መሳርሒኹም ተዓጽዮምኩም"],
      },
      data: {
        title: "ናይ ዳታ ምምላስ እና ናይ መሳርሒ ምእታው",
        blurb: "ስእልታት፣ ናይ ርክብ ቁጽርታት እና ፋይላት ኣብ ዝሞተ ወይ ዝተሰብረ መሳርሒ ተዓጽዮም። ሃርድዌሩ ምስ ዝፍቅድ ካብ ቴለፎናት እና ላፕቶፓት ዳታ ንምልስ — መሳርሂታት ባሕቲ እንተ ጸዒኑ እውን።",
        symptoms: ["መሳርሂታት ኣይሰርሕን ግን ዳታኡ አገዳሲ እዩ", "ስእልታት ወይ ፋይላት ኣብ ዝተሰብረ ቴለፎን ተዓጽዮም", "ዝተረስዑ ናይ ምስጢር ቃል ኩነታት", "ዝውድቅ ናይ ላፕቶፕ ድራይቭ"],
      },
      laptop: {
        title: "ናይ ላፕቶፕ ሃርድዌር እና ሶፍትዌር ደገፍ",
        blurb: "ስክሪናት፣ ቁልፊ ሰሌዳታት፣ ባትሪታት፣ ናይ ምዝበላ ምዕቃባት፣ ዝንቀሳቐሱ ስርዓታት እና ናይ ቫይረስ ጽሩይ — MacBook እና Windows ላፕቶፓት ከም ቴለፎናት ሓደ ተመሳሳሊ ጥንቃቐ ይረክቡ።",
        symptoms: ["ዝተሰንደቐ ናይ ላፕቶፕ ስክሪን", "ዝሞቱ ቁልፍታት ወይ ዝተሳሓተ ፊደላት", "ላፕቶፑ ድንገት ኣዝዩ ዝንቀሳቐስ", "ኣይሙላን ወይ ሓይሊ ኣይደቐን"],
      },
      diagnostics: {
        title: "ምርመራ እና ናይ ጽገና ምኽኻር",
        blurb: "እንታይ ከም ዝኾነ ኣይትፈልጥን ዲኹም? አምጽእዎ። ነቲ መሳርሒ ንመርምር፣ ብቀሊል ቋንቋ እንታይ ከም ዝኸውን ንነግረኩም፣ ቅድሚ ምጅማር ስራሕ ነቲ ጽገና ንግምት።",
        symptoms: ["ዝኾነ ነገር ስሕተት ኣለ ግን እንታይ ከም ዝኾነ ግልጺ ኣይኮነን", "ኣብ ካልእ ድኳን ዋጋ ካልኣይ ርእይቶ", "ኣሮጌ መሳርሒ — ክጽግን ይግብኦ ድዩ?", "ብሓደ ግዜ ብዙሕ ጸገማት"],
      },
      cleaning: {
        title: "ዓሚቕ ናይ ጽሩይ ኣገልግሎት",
        blurb: "ናይ ኪስ ጭራቕ እና ብኽሊ ብሕጂ ተናቃጺ፣ መኽፈብታትን ቁልፍታትን የዓፍኑ። ነቲ መሳርሒ ንኽፍቶ ውሽጡን ወጻኡን ብምሉእ ንጽርጎ — ብዙሕ ግዜ ዝተደበለለ ድምጽን ዝተላግቡ ቁልፍታትን የፈትሕ።",
        symptoms: ["ዝተደበለለ ወይ ትሑት ተናቃጺ", "ናይ ቻርጅ መኽፈቢ ጭራቕ ዝመልኦ", "ዝተላግቡ ወይ ዝተላከፉ ቁልፍታት", "ኣብ ትሕቲ ናይ ካሜራ መስታወት ብኽሊ"],
      },
    },
  },
  fixboth: {
    eyebrow: "ተሌፎናትን ላፕቶፕን",
    title: "ተሰባሪቑ ዘሎ ቴሌፎን። ተሰባሪቑ ዘሎ ላፕቶፕ። ሓደ ቦታ።",
    steps: [
      "iPhone 17 Pro Max — ተሰባሪቁ ስክሪንን ድኽሪ መነጽርን",
      "የዊንዶውስ ላፕቶፓት — HP፣ Dellን ካልኦትን",
      "MacBook — ስክሪናት፣ ባትርታት፣ ኪቦርዳት",
      "ከም አዲስ ሒዙካ ይሰርሕ ወሰዶ",
    ],
    cta: "ናደ ጥገና ግምት ይጠይቕ",
  },
  buy: {
    shopLink: "ቴለፎናት ርአ",
    eyebrow: "ሓደሽቲ እና ናይ ካልኣይ ኢድ ቴለፎናት",
    titleA: "ግዢ እና",
    titleEm: "ጽገና",
    titleB: "— ሓደ ድኳን፣ ክልቲኡ።",
    lede: "ሓደሽቲ እና ናይ ካልኣይ ኢድ ቴለፎናት ንሸጥ — Samsung፣ iPhone እና Google Pixel — ኩሎም ዝተፈተኑ፣ ንቁሕ እና ንኣገልግሎት ድልው። ናይ ካልኣይ ኢድ ማለት ብዝግቡእ ኩነታት ጥራይ።",
    perks: [
      { title: "ካብ 6–12 ወርሒ ዋሕዚ", body: "ኩሉ ቴለፎን ካብ 6 ወርሒ ክሳብ ሙሉኡ ዓመት ዋሕዚ ኣለዎ።" },
      { title: "ነጻ መከላኸሊ + ከድኒ", body: "የquality ዝተደንዘነ ናይ ስክሪን መከላኸሊ እና ናይ ቴለፎን ከድኒ፣ ምስ እያንዳንዱ ዝገዝእክዎ ቴለፎን ነጻ።" },
      { title: "ናይ ተገልጋሊ ቅናሻት", body: "ኩሉ ግዢ ናብ መለለዪ ቅናሻት የውስከካ — ክትገዛ ከለኻ ትዕቅብ።" },
      { title: "ዝተፈተነ እና ንቁሕ", body: "ብምሉእ ዝተፈተነ፣ ንቁሕ እና ካብ ድኳን ምስ ወጸካ ንኣገልግሎት ድልው።" },
    ],
    bestPrice: "ኣብ ካልጋሪ እና ኤድመንተን — ብትኽክል ኣብ ኩሉ አልበርታ ዝበለጸ ናይ ቴለፎን ዋጋ።",
    brandsTitle: "ነዚ ንሸጥ",
    seriesNote: "…እና ካልኦት ኣብ ድኳን። ንሎሚ ስቶክ ደውሉ።",
    cta: "ንሎሚ ስቶክ ደውሉ",
    iphoneLine: "iPhone 5 እና ካብኡ ንላዕሊ",
    pixelLine: "Pixel 6 እና ካብኡ ንላዕሊ",
  },
  showroom: {
    chapter: "ናይ ንዋያት ክፍሊ",
    eyebrow: "ተተላላኺ ንዋያት እና ናይ መዓልታዊ ቴክኖሎጂ",
    titleA: "ኒሕ፣",
    titleEm: "ብምዕራፍ ዝተመርጸ",
    titleB: "መደብር — መጋዘን ኣይኮነን።",
    lede: "ከድኒታት፣ መከላኸሊ፣ ሓይሊ እና ድምጺ፣ ንመዓልታዊ ህይወት ዝተመርጹ። ኣብዚ ዘሎ ኩሉ ኣብ ካውንተር ኣብ መሳርሒኹም ክትራግብ ወይ ክትፈትሽ ክኸእል እዩ።",
    groups: { all: "ኩሉ", phones: "ቴለፎናት", protection: "መከላኸሊ", power: "ሓይሊ", audio: "ድምጺ", wearables: "ሰዓታት", car: "መኪና", studio: "ስቱድዮ" },
    availability: "ምርካብ እና ዋጋ ኣብ ድኳን ይረጋገጽ",
    stripEyebrow: "ብኣካል ይርአይዎ",
    stripTitle: "መደብሩ ብዙሕ ግዜ ይለውጥ — ምዝራው ነጻ እዩ።",
    stripVisit: "ቆጸራኹም ይዘጋጅ",
    stripQuote: "ናይ ጽገና ግምት ርኸቡ",
    items: {
      cases: { title: "ናይ ቴለፎን ከድኒታት", blurb: "ቀጭን፣ ሓያል እና ግልጺ ከድኒታት ንትኽክለኛ ሞዴልኩም — ኣብ ድኳን ኣብ ቴለፎንኩም ፈትኑ።" },
      protectors: { title: "ናይ ስክሪን መከላኸሊ እና ናይ ካሜራ ውሕስነት", blurb: "ፕራይቨሲ እና ዝተደንዘነ ግላስ፣ ምስ ናይ ሌንዝ ውሕስነት — እንትጽበ ኣብ ካውንተር ይራግብ።" },
      cables: { title: "ኬብላት እና ቅልጡፍ ቻርጀራት", blurb: "ዝተፈትለ USB-C እና Lightning ኬብላት፣ ከምኡ ውን ጽሩይ ቅልጡፍ ቻርጀራት ን iPhone፣ Android እና ታብሌታት።" },
      power: { title: "ፓወር ባንካት እና ቻርጀራት", blurb: "ቅልጡፍ ናይ ካልእ ቻርጀራት፣ ብዙሕ መኽፈቢ ህባት እና ንጉዕዞ መዓልትታት ፓወር ባንካት።" },
      audio: { title: "AirPods እና ሄድፎናት", blurb: "AirPods፣ ዘይኬብል ናይ ጆሮ ማዳምጫታት እና ሄድፎናት — ንመዓልታዊ ምስማዕ።" },
      creator: { title: "ናይ ፈጠራ እና ናይ ቤት ስራሕ መሳርሒታት", blurb: "ትራይፖዶች፣ መዐቀቢታት፣ ናይ ቀለቤት መብራህቲታት እና ንድርቲታት፣ ትምህርቲታት እና ይዘት ኒህ ናይ ዴስክ ምዕቃባት።" },
      addons: { title: "ናይ መዓልታዊ ቴለፎን እና ላፕቶፕ ተተላላኺታት", blurb: "መዐቀቢታት፣ ሸፋኒታት፣ ህባት እና ዋና መሳርሒኹም ኣብ ህይወት ቀሊል ዝገብርዎ ኒህ ነገራት።" },
      preowned: { title: "መሳርሒታት እና ናይ ለውጢ ክፍልታት", blurb: "ኣብ ካውንተር ስለ ሕጂ ዘለዉ መሳርሒታት እና ናይ ለውጢ ክፍልታት ሓትቱ።" },
      phones: { title: "ሓደሽቲ እና ናይ ካልኣይ ኢድ ቴለፎናት", blurb: "Samsung፣ iPhone እና Google Pixel — ዝተፈተኑ፣ ንቁሕ እና ንኣገልግሎት ድልው፣ ካብ 6 ወርሒ ክሳብ ዓመት ዋሕዚ ምሳና።" },
      car: { title: "ናይ መኪና መሳርሒታት", blurb: "ናይ ቴለፎን ሃዋህቲ እና መዐቀቢታት፣ ከምኡ ውን ናይ ኬብል እና ዘይኬብል ናይ መኪና ቻርጀራት ንኩሉ መሳርሒ።" },
      speakers: { title: "ዘይኬብል ሚኒ ስፒከራት", blurb: "ተንቀሳቃሲ፣ ንደገ ዝዀኑ ስፒከራት — ዓቢይ ድምጺ ኣብ ኒህ ኣካል።" },
      smartwatches: { title: "ዝተወሃሂዱ ስማርት ሰዓታት", blurb: "ናይ መዓልታዊ ሰዓታት ዝብገስ ህርመት ልቢ ይዕቅቡ፣ ስጉምቲ ይቆጽሩ እና ምስ ቴለፎንካ ይራኸቡ።" },
      memory: { title: "ናይ ዝክርታ ካርድታት", blurb: "microSD ካርድታት ብኩሎም ዓቐናት፣ ንቴለፎናት፣ ካሜራታት እና ታብሌታት።" },
      keyboards: { title: "ናይ ቁልፊ ሰሌዳታት", blurb: "ናይ ኬብል እና ዘይኬብል ቁልፊ ሰሌዳታት ንስራሕ፣ ትምህርቲ እና ጸወታ።" },
      creatorkit: { title: "ናይ ይዘት ፍጠራ ኪትታት", blurb: "ናይ ቀለቤት መብራህቲታት፣ ተንቀሳቃሲ እና ዝጸንዑ ትራይፖዶች፣ እና ካልኦት ብዙሕ ንፈጠራውያን።" },
    },
  },
  visit: {
    chapter: "ቆጸራ እና ርክብ",
    eyebrow: "ይእተው",
    titleA: "ኣብ 17th Ave SE ዘሎ ድኳን፣",
    titleEm: "ብቀጥታ TD Bank ጎድኒ።",
    lede: "ኣብ ናይ ስራሕ ሰዓታት ውስጥ ብዘይ ቆጸራ ምኻድ የፍቅድ። ነቲ መሳርሒ ከም ዝኾነ አምጽእዎ — ቆጸራ ኣየድልን።",
    addressLabel: "ኣድራሻ",
    hoursLabel: "ናይ ስራሕ ሰዓታት",
    call: "ደውሉ",
    text: "ንድኳኑ ጹሑፍ ላኣኹ",
    email: "ብኢመይል ይረኽቡና",
    openMaps: "ኣብ ካርታ ክፈት",
    planEyebrow: "ቅድሚኡ ምዕቃብ ትመርጹ ዲኹም?",
    planTitle: "ጉዕዞኹም ቅድሚ ምጅማርኩም ቅዳማይ ግምት ርኸቡ።",
    planCta: "ናይ ጽገና ግምት ርኸቡ",
    mapTitle: "ናብ Next-G Phone Repair ካርታ",
  },
  quote: {
    eyebrow: "ናይ ጽገና ግምት",
    titleA: "ግልጺ ቁጽሪ፣",
    titleEm: "ኣብ ሓደ ደቒቕ ገምጋም።",
    lede: "ሰለስተ ቅልጡፍ ምርጫታት እንታይ ከም ዝኸውን የነግሩና። ድሕሪኡ ደውል — ብቀጥታ ግልጺ ዋጋ ንህበካ፣ ስራሕ ቅድሚ ምጅማሩ ንስኻ ትፅድቕ።",
    step: "ደረጃ",
    of: "ካብ",
    stepTitle1: "እንታይ ንጽግን?",
    stepTitle2: "ኣየናይ ትውልዲ፣ ብግምት?",
    stepTitle3: "እንታይ ይገብር ኣሎ?",
    back: "ምለስ",
    preliminary: "ቅዳማይ ግምት",
    planning: "ናይ እቅድ ክልል",
    factorsTitle: "ናይ መወዳእታ ዋጋ ዝውስኑ",
    factors: [
      "ትኽክለኛ ሞዴል እና ንኡ ዝርከብ ናይ ክፍሊ ጽሩይነት",
      "ጉድኣቱ ኣብ ውሽጢ መሳርሂታት ክንደይ ከም ዝተስፋሕፋሐ",
      "ናይ ክፍልታት ምርካብ እና ናይ እቲ ሰሙን ናይ አቅራቢ ዋጋታት",
      "ኣብ ነጻ ምርመራ ግዜ ዝርከቡ ተተላላኺ ጸገማት",
    ],
    disclaimer: "እዚ ቅዳማይ እና ዘይኣገባብነት ክልል እዩ። ክፍልታት፣ ትኽክለኛ ሞዴል፣ ምርመራ እና ምርካብ ናይ መወዳእታ ዋጋ ክለውጡ ይኽእሉ — ስራሕ ቅድሚ ምጅማሩ ኩሉ ግዜ ምሳኹም ይረጋገጽ።",
    call: "ደውሉ",
    text: "ነዚ ግምት ብጹሑፍ ላኣኽዎ",
    email: "ንድኳኑ ኢመይል ላኣኹ",
    startOver: "እንደገና ጀምር",
    visitShop: "ድኳኑ ይቐረቡ",
    categories: {
      iphone: { label: "iPhone", blurb: "ኩሎም ትውልድታት፣ ካብ iPhone 8 ክሳብ ናይ ቀረባ ግዜ Pro ሞዴላት።" },
      android: { label: "Android ቴለፎን", blurb: "Samsung፣ Google Pixel እና ካልኦት Android መሳርሒታት።" },
      tablet: { label: "ታብሌት", blurb: "iPad እና Android ታብሌታት ብኩሎም ዓቐናት።" },
      laptop: { label: "ላፕቶፕ", blurb: "MacBook እና Windows ላፕቶፓት፣ ሃርድዌር እና ሶፍትዌር።" },
    },
    tiers: {
      iphone: {
        older: { label: "ኣሮጌ iPhone", hint: "iPhone 8፣ X እና SE-ትውልዲ መሳርሒታት" },
        recent: { label: "ናይ ቀረባ ግዜ iPhone", hint: "iPhone 11 – 14 ዘመን" },
        newest: { label: "ሓዲሽ / Pro iPhone", hint: "iPhone 15 – 17 እና Pro ሞዴላት" },
      },
      android: {
        standard: { label: "መደበኛ Android", hint: "ናይ መእተዊ እና ማእኸላይ ደረጃ ቴለፎናት" },
        recent: { label: "ናይ ቀረባ ግዜ Android", hint: "ናይ ቀረባ ግዜ ዋና ሞዴላት" },
        flagship: { label: "ፍላግሺፕ Android", hint: "Galaxy S / Ultra፣ Pixel Pro እና ተመሳሳሊታት" },
      },
      tablet: {
        standard: { label: "መደበኛ ታብሌት", hint: "ናይ መዓልታዊ እና ኣሮጌ ታብሌታት" },
        recent: { label: "ናይ ቀረባ ግዜ ታብሌት", hint: "ናይ ቀረባ ግዜ iPad እና Android ሞዴላት" },
        pro: { label: "Pro ታብሌት", hint: "iPad Pro እና ዓበይቲ ፕሪሚየም ታብሌታት" },
      },
      laptop: {
        standard: { label: "መደበኛ ላፕቶፕ", hint: "ናይ መዓልታዊ እና ኣሮጌ ላፕቶፓት" },
        recent: { label: "ናይ ቀረባ ግዜ ላፕቶፕ", hint: "ናይ ቀረባ ግዜ ዋና እና ultrabook ሞዴላት" },
        pro: { label: "ጸወታ / Pro ላፕቶፕ", hint: "ናይ ጸወታ ማሽናት፣ MacBook Pro እና ናይ ስራሕ ጣቢያታት" },
      },
    },
    issues: {
      screen: { label: "ዝተሰብረ ስክሪን", hint: "ስንደቓት፣ ዝሞቱ ፒክስላት ወይ ናይ ምንካፍ ጸገማት" },
      battery: { label: "ናይ ባትሪ ለውጢ", hint: "ቅልጡፍ ምውዳቅ፣ ምጥፋእ፣ ህንፋሕ ወይ ደኸም ጥዕና" },
      charging: { label: "ናይ ቻርጅ ጸገም", hint: "ዝተፈትሐ መኽፈቢ፣ ዘይምሙላት ወይ ዝቋረጽ ሓይሊ" },
      backglass: { label: "ዝተሰብረ ናይ ድሕሪት መስታወት", hint: "ዝተሰንደቐ ናይ ድሕሪት መስታወት ወይ ናይ ካብሌት ጉድኣት" },
      camera: { label: "ናይ ካሜራ ጸገም", hint: "ዝተጎድአ ሌንዝ፣ ናይ ትኩረት ጸገማት ወይ ዝወደቐ ሞጁል" },
      water: { label: "ናይ ማይ ጉድኣት", hint: "ናይ ርጥበት ርክብ፣ ኮሮዥን ወይ ሓይሊ የብሉን" },
      software: { label: "ናይ ሶፍትዌር ጸገም", hint: "ምቕራባት፣ ምሕደሳታት፣ ምጅማር ወይ ናይ ኣካውንት ጸገማት" },
      data: { label: "ናይ ዳታ ምምላስ", hint: "ስእልታት፣ ፋይላት ወይ ናይ መሳርሒ ምእታው ጸገማት" },
    },
    smsBody: "ሰላም Next-G፣ ብማለት ጽገና እየ እደውል። መሳርሒ፦ {device}። ጸገም፦ {issue}።",
    emailSubject: "ናይ ጽገና ሕጽንታ — Next-G",
    resultTitle: "ድሉው እዩ — ሕጂ ጥራይ ደውል።",
    callNow: "ሕጂ ደውል",
    callLead: "ኩሉ ጽገና የተፈላሊ እዩ፣ ስለዚ ኣብ ኦንላይን ንግመት ንካልእ ብቀጥታ ንጽግነካ። ነዚ ዝርዝር ሒዝካ ደውል እና ብቀጥታ ቀጥተኛ መልሲ ትረክብ።",
    readyTitle: "ክትደውል ከለኻ ነዚ ይዘጋጅ",
    ready: ["ትኽክለኛ ሞዴልካ፣ እንተ ፈሊጥካ", "መሳርሂታት እንታይ ከም ዝገብር — ወይ ዘይገብር", "ጸገሙ መዓስ ከም ዝጀመረ"],
    noPrice: "ብዘይ ፍቓድካ ስራሕ ኣይጅምርን። ኣብ ተሌፎን ዝዀነ ዋጋ ንስኻ ትሰማማዕ ኣለካ።",
  },
  footer: {
    explore: "ይዝርግሑ",
    talk: "ይረኽቡና",
    hours: "ሰዓታት",
    quote: "ግምት ርኸቡ",
    rights: "ካልጋሪ፣ አልበርታ",
    line: "ብዘይ ቆጸራ ምኻድ የፍቅድ · ግምታት ስራሕ ቅድሚ ምጅማሩ ይረጋገጹ",
    motto: "ንናይ ሓድሽ ትውልዲ ናይ ሓድሽ ትውልዲ ኣገልግሎት።",
  },
};
